import { ApprovalRequestState } from '../../api'
import { type ApiApprovalRequest } from '../../api/common'

export const isApprovalRequestOpen = (approvalRequest: ApiApprovalRequest): boolean =>
  approvalRequest.requestState === ApprovalRequestState.Pending ||
  approvalRequest.requestState === ApprovalRequestState.Publishing
